import React from 'react';
import { Route, Routes } from 'react-router-dom';
import List from './components/List';
import Details from './components/Details';
import { MODES } from 'utils/constants';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { customersReducer, customersSlice } from './redux/slice';
import { customersSaga } from './redux/saga';

const Customers = () => {
    useInjectReducer({ key: customersSlice, reducer: customersReducer });
    useInjectSaga({ key: customersSlice, saga: customersSaga });
    
    return (
        <Routes>
            <Route path="/" element={<List />} />
            <Route path=":id/view" element={<Details mode={MODES.VIEW} />} />
            <Route path="new" element={<Details mode={MODES.NEW}  />} />
            <Route path=":id/edit" element={<Details mode={MODES.EDIT}  />} />
        </Routes>      
    );
};

export default Customers;
